import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'gen-user-counter-table',
  templateUrl: './user-counter-table.component.html',
  styleUrls: ['./user-counter-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserCounterTableComponent implements OnInit {
  public payload: { patientWarningList: any[], selected: string };
  public tunnel$: Subject<any>;
  public callback: (selectedUserId: string) => void;
  public selectedUser: string;

  constructor() {
  }

  ngOnInit() {
    this.setSelected(this.payload.selected);
    this.tunnel$
      .asObservable()
      .filter(message => message.emitter != 'children' && message.value)
      .map(message => message.value)
      .subscribe((data) => {
        this.callback(this.selectedUser);
        this.tunnel$.next({ emitter: 'children', value: 1});
      });
  }

  setSelected(id: string) {
    this.selectedUser = id;
  }

  trackByFn(item, index) {
    return item ? item.id : index;
  }

}
